import { ITableRow } from "@common/models/Document/ITableRow";
import { formatMarkdownTableCell } from "@app/utils";

export function convertDeltaTableDictToMarkdown(
    data: ITableRow[],
    tableName: string
): string {
    let markdownTable = '';
    markdownTable = '| Column | DataType | Description |\n';
    markdownTable += '|--------|----------|-------------|\n';

    for (const item of data) {
        markdownTable += `| ${formatMarkdownTableCell(item.col_name)} | ${formatMarkdownTableCell(item.data_type)} | ${formatMarkdownTableCell(item.comment)} |\n`;
    }

    return markdownTable;
}
